// Ligne de pénalité (retard/absence) d'une communauté pour un event non-décès.
// Champs volontairement simples (pas d'Enumify) pour éviter tout crash de parsing
// si le backend introduit une nouvelle valeur.
export default class EventPenality {
    public id: string               // référence event_community
    public community: string
    public communityAcronym: string
    public communityReference: string
    public presenceStatus: string   // LATE | ABSENT
    public penalityType: string     // LATE | ABSENCE
    public penalityDue: number
    public penalityCollected: number
    public penalityPaymentStatus: string   // UNPAID | PROCESSING | PAID

    constructor(data: any) {
        this.id = data.reference
        this.community = data.community
        this.communityAcronym = data.communityAcronym
        this.communityReference = data.communityReference
        this.presenceStatus = data.presenceStatus
        this.penalityType = data.penalityType
        this.penalityDue = data.penalityDue
        this.penalityCollected = data.penalityCollected
        this.penalityPaymentStatus = data.penalityPaymentStatus
    }
}
